export default "__VITE_ASSET__C0_6_ymt__"